import React from 'react';
import { withStyles } from '@material-ui/core';
import SearchBox from '../../../../../../common/SearchBox';
import BulkEditor from '@dataGrid/components/bulkEditor';
import ClearAllFilterButton from '@dataGrid/components/columnFilters/ClearAllFilterButton';

const styles = (theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: 8
  },
  title: {
    fontSize: theme.headerTextFontSize,
    color: theme.palette.primary.main,
    fontWeight: 600
  },
  headerIconStyles: {
    padding: '5px 10px',
    borderLeft: `1px solid ${theme.AppBGColor}`,
    color: theme.iconColor,
    float: 'right',
    display: 'flex',
    alignItems: 'center',
    '&>span': {
      padding: '10px 10px',
      color: theme.iconColor
    }
  },
  disableIcon: {
    cursor: 'not-allowed',
    opacity: 0.7
  },
  enableIcon: {
    cursor: 'pointer'
  },
  actionsContainer: {
    display: 'flex',
    alignItems: 'center'
  }
});

const GridHeader = ({
  classes,
  title,
  gridApi,
  showBulkEdit,
  showSearchBar,
  updateSearchText,
  handleBulkUpdate
}) => {
  return (
    <div className={classes.container}>
      <div className={classes.title}>{title}</div>
      <div className={classes.actionsContainer}>
        {showBulkEdit && <BulkEditor gridApi={gridApi} handleBulkUpdate={handleBulkUpdate} />}
        {showSearchBar && <SearchBox onChange={updateSearchText} />}
        <ClearAllFilterButton gridApi={gridApi} />
      </div>
    </div>
  );
};

export default withStyles(styles)(GridHeader);
